<div class="internal-committee-page">
  <app-header-style-seven></app-header-style-seven>

  <section class="page-shell internal-committee-shell">
    <div class="custom-container">
      <div class="content-shell internal-committee-content-shell">
        <!-- HERO -->
        <header class="page-hero">
          <span class="page-kicker">Safety &amp; Dignity</span>
          <h1>Internal Complaint Committee</h1>
          <p>
            Committee constituted under the POSH framework to address complaints,
            support redressal, and ensure a safe and respectful campus environment.
          </p>
        </header>

        <!-- INTRO -->
        <section
          class="info-card"
          [class.dark-experience-area]="themeService.isDark()"
        >
          <div class="info-copy">
            <p>
              The Sexual Harassment of Women at Workplace (Prevention,
              Prohibition and Redressal) Act, 2013 is India’s law for the
              prevention, prohibition, and redressal of sexual harassment of
              women at the workplace.
            </p>
            <p>
              The Act, together with its rules, is collectively called the POSH
              law. It builds upon the Vishaka guidelines laid down by the Supreme
              Court of India in 1997 and applies to women working in private,
              government, and informal sectors.
            </p>
          </div>
        </section>

        <!-- COMMITTEE -->
        <section class="panel-card">
          <div class="panel-head">
            <div>
              <span class="panel-tag">POSH Committee</span>
              <h2>Internal Complaint Committee</h2>
            </div>

            <a
              class="pdf-link"
              href="assets/pdfs/internal.pdf"
              target="_blank"
              rel="noopener"
            >
              Open PDF
            </a>
          </div>

          <div class="row g-4 align-items-start">
            <div class="col-lg-4 col-md-12">
              <div class="pdf-card">
                <a href="assets/pdfs/internal.pdf" target="_blank" rel="noopener">
                  <img
                    src="assets/pdfs/iic.jpg"
                    class="pdf-image"
                    alt="Internal Complaint Committee PDF preview"
                    loading="lazy"
                  />
                </a>
                <div class="pdf-caption">Committee resolution / PDF preview</div>
              </div>
            </div>

            <div class="col-lg-8 col-md-12">
              <div class="table-wrap">
                <table class="table committee-table">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Member Name</th>
                      <th>Designation</th>
                      <th>Position</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let m of committeeMembers; trackBy: trackBySno">
                      <td>{{ m.sno }}</td>
                      <td>{{ m.memberName }}</td>
                      <td>{{ m.designation }}</td>
                      <td>{{ m.position }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</div>